import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import { useState, useEffect, useRef } from "react";
import toast from "react-hot-toast";

import { selectCurrentUser } from "../../redux/user/user.selectors";
import { setCurrentDistro } from "../../redux/distro/distro.actions";
import { selectCurrentDistro } from "../../redux/distro/distro.selector";
import { sessionExpired, updateToken } from "../../redux/user/user.actions";
import { authFetch, getApiUrl, SessionExpiredError } from "../../utils/api";

import PageWrapper from "../../components/page-wrapper/page-wrapper.components";
import AdvisorsSection from "../../components/advisors/advisors.component";
import { SectionWrapper } from "../../components/section-wrapper/sectionWrapper.styles";

const AdvisorsPage = ({ currentUser, currentDistro, setCurrentDistro, onSessionExpired, onTokenRefresh }) => {
  const [userInfo, setUserInfo] = useState({});
  const [loadingError, setLoadingError] = useState(false);
  const toastIdRef = useRef(null);
  const apiUrl = getApiUrl();
  const authParams = { currentUser, onSessionExpired, onTokenRefresh };

  const fetchData = async (distroId) => {
    toastIdRef.current = toast.loading('Loading advisors...');
    try {
      const response = await authFetch(
        `${apiUrl}/users/${currentUser.id}/${distroId}`,
        {},
        authParams
      );
      if (response.ok) {
        const data = await response.json();
        setUserInfo(data);
        toast.dismiss(toastIdRef.current);
      } else {
        toast.error('Failed to load advisors', { id: toastIdRef.current });
        setLoadingError(true);
      }
    } catch (err) {
      toast.dismiss(toastIdRef.current);
      if (!(err instanceof SessionExpiredError)) {
        setLoadingError(true);
      }
    }
  };

  useEffect(() => {
    if (currentUser.distros.length === 1) {
      setCurrentDistro(currentUser.distros[0].id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (currentDistro !== null) {
      fetchData(currentDistro);
    }
    return () => {
      if (toastIdRef.current) {
        toast.dismiss(toastIdRef.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentDistro]);

  return (
    <PageWrapper>
      {Object.entries(userInfo).length > 0 && !loadingError ? (
        <AdvisorsSection advisors={userInfo.advisors} />
      ) : loadingError ? (
        <SectionWrapper>
          <h1 className="text-center">
            An error has occured while retrieving data. Please refresh the
            page and try again.
          </h1>
        </SectionWrapper>
      ) : null}
    </PageWrapper>
  );
};

const mapStateToProps = createStructuredSelector({
  currentUser: selectCurrentUser,
  currentDistro: selectCurrentDistro,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentDistro: (data) => dispatch(setCurrentDistro(data)),
  onSessionExpired: () => dispatch(sessionExpired()),
  onTokenRefresh: (token) => dispatch(updateToken(token)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdvisorsPage);
